//prefixes for iana names..
export default [
  'africa',
  'america',
  'asia',
  'atlantic',
  'australia',
  'brazil',
  'canada',
  'chile',
  'europe',
  'indian',
  'mexico',
  'pacific',
  'antarctica',
  'etc'
]
